import { useCalcDatesForPromotion } from '@hooks/useCalcDatesForPromotion'
import { PROMOTION_FOR_FREE_PLAN } from '@hooks/useSale'
import { getVoucherValueForFreePlanPromotion } from '@pages/Checkout/helpers/getVoucherValue'
import { useGetPromotions } from '@pages/Checkout/hooks/useGetPromotions'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { CountdownTimer, Heading, Spacer } from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import styles from './PromotionForFreePlan.module.scss'

export const PromotionForFreePlan = () => {
  const { t } = useTranslation()

  const { chosenBillingPeriod, accountCurrency } = useCheckoutContext()

  const { date } = useCalcDatesForPromotion()

  const promotions = useGetPromotions({
    billingPeriod: chosenBillingPeriod
  })

  const { isVisible } = promotions[PROMOTION_FOR_FREE_PLAN]

  const voucherValue = t(getVoucherValueForFreePlanPromotion(accountCurrency))

  return isVisible ? (
    <Fragment>
      <Row
        vertical='center'
        horizontal='center'
        className={styles.promotion__container}
      >
        <CountdownTimer {...date} variant='success' />

        <Heading level={3}>
          <Trans
            i18nKey='account.package.promo-banner.free.plans.trigger'
            components={{
              promo: <span className={styles.promotion__promo} />
            }}
            values={{
              voucherValue
            }}
          />
        </Heading>
      </Row>

      <Spacer space={40} />
    </Fragment>
  ) : null
}

PromotionForFreePlan.displayName = 'CheckoutPlansBannersPromotionForFreePlan'
